import { AuthorizationState } from '@vacasa/react-components-lib';

export const clearAuthFromLocalStorage = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('idToken');
    localStorage.removeItem('nonce');
    localStorage.removeItem('state');
};
/**
 * Check authorization state AND CMS session state for employee flag
 * @param auth
 * @returns
 */
export const isEmployee = (auth?: AuthorizationState) => {
    return auth?.isEmployee || Vacasa?.ExternalJS.user.isEmployee || false;
};
